import React from 'react';
import styled from 'styled-components';
import _ from 'lodash';

import { CarFiltersWrapper, FiltersActive } from './CarFiltersWrapper';
import Select from '../Select';

import availableNowWhite from '../../assets/icons-main/available-now.png';
import times from '../../assets/icons-main/times.png';

const Checkbox = styled.div`
    position: relative;
    display: flex;
    padding-top: 23px;
    border-right: 1px solid #8f9092;
    padding-left: 20px;

    @media (max-width: 767.98px) {
        border-right: none;
    }

    img {
        position: absolute;
        width: 35px;
        left: 53px;
        top: 25px;
    }

    checkbox {
        border-radius: 0;
        border: 1px solid #ff5000;
        background: transparent;
    }

    input[type='radio'],
    input[type='checkbox'] {
        display: none;
    }

    label {
        position: relative;
        color: #8f9092;
        font-family: 'Roboto Mono';
        line-height: 2;
    }

    .checkbox {
        display: inline-block;
        cursor: pointer;
        padding-left: 85px;
    }

    .checkbox:before {
        content: '';
        display: inline-block;
        width: 20px;
        height: 20px;
        vertical-align: middle;
        background-color: #000;
        border: 1px solid #8f9092;
        text-align: center;
        margin-right: 10px;
        position: absolute;
        left: 0;
        top: 3px;
    }

    input[type='checkbox']:checked + .checkbox:before {
        color: #ffffff;
        background-color: #000;
        padding-top: 5px;
    }

    .checkbox:after {
        content: '';
        display: inline-block;
        width: 10px;
        height: 10px;
        vertical-align: middle;
        /* background-color: #fff; */
        text-align: center;
        margin-right: 10px;
        left: 5px;
        position: absolute;
        top: 8px;
    }

    input[type='checkbox']:checked + .checkbox:after {
        color: #ffffff;
        background-color: #ff5000;
        padding-top: 5px;
    }

    .checkbox span {
        padding-left: 10px;
    }

    label {
        max-width: 150px;
        font-size: 10px;
        line-height: 1.5;
        font-weight: 600;
        color: #7f7f7f;
        margin: 0;
    }
`;

class CarFilters extends React.Component {
    state = {
        availableNow: false,
        typpojazdu: [],
        typnadwozia: [],
        marka: [],
        rodzajpaliwa: [],
        skrzynia: [],
        sort: [],
        priceTo: []
    };

    onChange = state => {
        if (_.get(state, 'target.type', '') === 'checkbox') {
            return this.setState(
                {
                    ...this.state,
                    availableNow: !this.state.availableNow
                },
                () => {
                    this.props.setFilters(this.state);
                }
            );
        }

        this.setState(
            {
                ...this.state,
                ...state
            },
            () => {
                this.props.setFilters(this.state);
            }
        );
    };

    removeFilter = item => {
        // console.log("removeFilter", this.state[item.taxonomy]);

        this.setState(
            {
                [item.taxonomy]: this.state[item.taxonomy].filter(
                    findItem => findItem.slug !== item.slug
                )
            },
            () => {
                this.props.setFilters(this.state);
            }
        );
    };

    render() {
        const mergedArray = [
            ...this.state.typnadwozia,
            ...this.state.marka,
            ...this.state.rodzajpaliwa,
            ...this.state.skrzynia
        ];

        return (
            <>
                <CarFiltersWrapper>
                    <div>
                        <Select
                            type="typpojazdu"
                            label="Typ"
                            onChange={this.onChange}
                            selected={this.state.typpojazdu}
                        />
                        <Select
                            type="typnadwozia"
                            label="Nadwozie"
                            isMulti
                            onChange={this.onChange}
                            parent={this.state.typpojazdu}
                            selected={this.state.typnadwozia}
                        />
                        <Select
                            type="marka"
                            label="Marka"
                            isMulti
                            onChange={this.onChange}
                            parent={this.state.typpojazdu}
                            selected={this.state.marka}
                        />
                        <Select
                            type="rodzajpaliwa"
                            label="Paliwo"
                            isMulti
                            onChange={this.onChange}
                            selected={this.state.rodzajpaliwa}
                        />
                        <Select
                            type="skrzynia"
                            label="Skrzynia"
                            isMulti
                            onChange={this.onChange}
                            selected={this.state.skrzynia}
                        />
                        <Select
                            type="priceTo"
                            label="Rata do"
                            onChange={this.onChange}
                            options={[
                                { slug: '1300', name: '1300 ZŁ' },
                                { slug: '2000', name: '2000 ZŁ' },
                                { slug: '3000', name: '3000 ZŁ' },
                                { slug: '0', name: 'MAX' }
                            ]}
                            selected={this.state.priceTo}
                        />
                    </div>
                    <div>
                        <Checkbox>
                            <img
                                src={availableNowWhite}
                                alt="Car is available for now button"
                            />
                            <input
                                type="checkbox"
                                // id="availableNow"
                                id="checkbox-stream-6"
                                value={this.state.availableNow}
                                onClick={this.onChange}
                            />
                            <label
                                htmlFor="checkbox-stream-6"
                                className="checkbox"
                            >
                                DOSTĘPNE OD RĘKI
                            </label>
                        </Checkbox>
                        <Select
                            type="sort"
                            label="Sortuj"
                            onChange={this.onChange}
                            options={[
                                {
                                    slug: 'sort-from',
                                    name: 'Cena od najtańszej'
                                },
                                { slug: 'sort-to', name: 'Cena od najdrożej' },
                                { slug: 'sort-new', name: 'Od najnowszych' }
                            ]}
                            selected={this.state.sort}
                        />
                    </div>
                </CarFiltersWrapper>
                <FiltersActive>
                    {mergedArray.map(item => {
                        return (
                            <span>
                                {item.name}
                                <img
                                    onClick={this.removeFilter.bind(this, item)}
                                    src={times}
                                    alt="Times icon for remove filter"
                                />
                            </span>
                        );
                    })}
                </FiltersActive>
            </>
        );
    }
}

export default CarFilters;
